module.exports = __webpack_public_path__ + "img/new-warriors.2edbafe2.svg";